import { API_METHODS } from './api.enums';
import { apiAction } from './utils.actions';
import { EmbeddingSearchModel } from '../../types/embeddingSearch.types';
import {
    AdminAiMatchRejectionFilter,
    AdminJobCvRejectionReason,
} from '../../common/admin_job_cv_rejection_reason.enum';

export const JOBS_SEARCH_PAGE_SIZE = 40;

export type CandidateJobSearchMode = 'search_keys' | 'cv_general' | 'cv_summary';

export type SearchJobsForCandidateBody = {
    userId: number
    mode: CandidateJobSearchMode
    latitude?: number
    longitude?: number
    distance?: number
    page?: number
    pageSize?: number
    offset?: number
    rejectionFilter?: AdminAiMatchRejectionFilter
    onlyInternal?: boolean
    embeddingModel?: EmbeddingSearchModel
}

export type JobRecord = {
    jobId: number
    title: string
    companyName?: string
    location?: string
    description?: string
    summary?: string
    similarity: number
    rankingScore?: number
    updatedAt?: string
    adminRejection?: {
        reasonCode: AdminJobCvRejectionReason
        createdAt: string
    }
}

export type SearchJobsForCandidateResponse = {
    jobs: JobRecord[]
    hasMore: boolean
    sourceText?: string
    selectedCv?: {
        cvId: number
        name: string
        isDefault: boolean
    }
    autoLocation?: {
        formatted_address: string
        latitude: number
        longitude: number
    }
}

export const searchJobsForCandidateAI = (
    payload: SearchJobsForCandidateBody, backdrop = true,
) => apiAction<SearchJobsForCandidateResponse>({
    url: '/api/admin/jobs/search-for-candidate',
    method: API_METHODS.POST,
    payload,
    backdrop,
});
